import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchTodosByClientId, createTodo, deleteTodo } from "./todo";
import { toast } from "react-toastify";

export const useTodos = (clientId: string) => {
  const queryClient = useQueryClient();

  // FETCH TODOS
  const todosQuery = useQuery({
    queryKey: ["todos", clientId],
    enabled: !!clientId,
    queryFn: () => fetchTodosByClientId(clientId),
    staleTime: 5 * 60 * 1000,
  });

  // ADD TODO
  const addTodoMutation = useMutation({
    mutationFn: (todo: any) => createTodo(todo),
    onSuccess: () => {
      toast.success("Todo added");
      queryClient.invalidateQueries({ queryKey: ["todos", clientId] });
    },
  });

  // DELETE TODO
  const deleteTodoMutation = useMutation({
    mutationFn: (id: string) => deleteTodo(id),
    onSuccess: () => {
      toast.success("Todo removed");
      queryClient.invalidateQueries({ queryKey: ["todos", clientId] });

    },
  });

  return {
    todosQuery,
    addTodoMutation,
    deleteTodoMutation,
  };
};
